import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import Footer from './Footer';

export default function LegalLayout({ title, updated, children }) {
  const navigate = useNavigate();
  const goHome = (goto) => navigate('/', goto ? { state: { goto } } : undefined);

  return (
    <div className="relative bg-bone min-h-screen">
      <header className="fixed top-0 left-0 w-full z-[70] bg-white/60 backdrop-blur-xl border-b border-black/5">
        <div className="mx-auto max-w-[1400px] px-6 md:px-12 h-20 flex items-center justify-between">
          <Link to="/" className="serif italic text-2xl tracking-tight" data-testid="legal-logo-home">
            RaufMedia
          </Link>
          <button
            onClick={() => goHome('contact')}
            className="px-6 py-3 rounded-full bg-signal text-bone font-sans text-xs uppercase tracking-[0.2em] hover:bg-obsidian transition-colors duration-300"
            data-testid="legal-contact-cta"
          >
            Contact
          </button>
        </div>
      </header>

      <main className="pt-40 pb-24 md:pb-32">
        <div className="mx-auto max-w-[820px] px-6 md:px-12">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, ease: [0.76, 0, 0.24, 1] }}
          >
            <span className="font-sans text-xs uppercase tracking-[0.3em] text-graphite">Legal</span>
            <h1 className="serif tracking-tighter text-[13vw] md:text-[6vw] leading-[0.9] mt-4 mb-6">
              {title}
            </h1>
            <p className="font-sans text-sm text-graphite mb-16">Last updated: {updated}</p>
          </motion.div>

          <div className="legal-prose font-sans text-graphite leading-relaxed space-y-8">
            {children}
          </div>
        </div>
      </main>

      <Footer onNav={goHome} />
    </div>
  );
}
